// extracted by mini-css-extract-plugin
module.exports = {"tablet":"482px","medium-tablet":"767px","desktop":"1025px"};